import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import {Storage} from "../Utils/StorageUtils";
import {GATEWAY_URL} from "./Constants";

const TIMEOUT = 30 * 1000;
axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = GATEWAY_URL;

export function setupInterceptorsTo(onUnauthenticated: () => void): void {

    const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
        const token = Storage.local.get('api-token-key') || Storage.session.get('api-token-key');
        const email = Storage.local.get('user-mail') || Storage.session.get('user-mail');

        if (config && token && config.url !== "api/authenticate") {
            config.headers = config.headers ?? {};
            config.headers.Authorization = `Bearer ${token}`;
            if (email) {
                config.headers['Email'] = email;
            }
        }
        return config;
    }

    const onRequestError = (error: AxiosError): Promise<AxiosError> => {
        return Promise.reject(error);
    }

    const onResponse = (response: AxiosResponse): AxiosResponse => {
        return response;
    }

    const onResponseError = (error: AxiosError): Promise<AxiosError> => {

        const status = error.status || (error.response ? error.response.status : 0);
        const method = error.config?.method?.toLowerCase();
        const url = String(error.config?.url ?? '');
        const isManagementDataQuery = url.includes('api/management-data/');
        const isManagementOverviewQuery =
            method === 'post' &&
            url.includes('api/management-data/overview') &&
            !url.includes('download');
        if (status === 401) {
            if (!isManagementOverviewQuery) {
                window.history.pushState(undefined,"undefined unused", "/");
                onUnauthenticated();
            }
            return Promise.reject(error);
        }
        if (status === 403) {
            const isTeleobjectMutation =
                method === 'post' &&
                url.includes('api/teleobject/inhibition') &&
                !url.includes('search');
            // Saving a user answers 403 for business refusals (power station access); the form shows the detail.
            const isUserSaveMutation =
                (method === 'post' || method === 'put') &&
                /^api\/users(\/\d+)?$/.test(url);
            if (!isTeleobjectMutation && !isManagementDataQuery && !isUserSaveMutation) {
                window.history.pushState(undefined,"undefined unused", "/");
                onUnauthenticated();
            }
        }

        return Promise.reject(error);
    }

    axios.interceptors.request.use(onRequest, onRequestError);
    axios.interceptors.response.use(onResponse, onResponseError);
}
